export var InviteUser;
(function (InviteUser) {
    InviteUser["InviteUserToOrganisation"] = "InviteUser/InviteUserToOrganisation";
    InviteUser["InviteUserToOrganisation_Successful"] = "InviteUser/InviteUserToOrganisation_Successful";
    InviteUser["InviteUserToOrganisation_Error"] = "InviteUser/InviteUserToOrganisation_Error";
    InviteUser["InviteUserToSuperorg"] = "InviteUser/InviteUserToSuperorg";
    InviteUser["InviteUserToSuperorg_Successful"] = "InviteUser/InviteUserToSuperorg_Successful";
    InviteUser["InviteUserToSuperorg_Error"] = "InviteUser/InviteUserToSuperorg_Error";
    InviteUser["FetchTeamMembers"] = "InviteUser/FetchTeamMembers";
    InviteUser["FetchTeamMembers_Successful"] = "InviteUser/FetchTeamMembers_Successful";
    InviteUser["FetchTeamMembers_Error"] = "InviteUser/FetchTeamMembers_Error";
    InviteUser["ClearInviteMessage"] = "InviteUser/ClearInviteMessage";
    InviteUser["FetchPendingInvites"] = "FetchPendingInvites";
    InviteUser["FetchPendingInvites_Successful"] = "FetchPendingInvites_Successful";
    InviteUser["FetchPendingInvites_Error"] = "FetchPendingInvites_Error";
    InviteUser["RevokeInvite"] = "RevokeInvite";
    InviteUser["RevokeInvite_Successful"] = "RevokeInvite_Successful";
    InviteUser["RevokeInvite_Error"] = "RevokeInvite_Error";
    InviteUser["ResendInvite"] = "ResendInvite";
    InviteUser["ResendInvite_Successful"] = "ResendInvite_Successful";
    InviteUser["ResendInvite_Error"] = "ResendInvite_Error";
})(InviteUser || (InviteUser = {}));
